import React from 'react';
import type { Module } from '../data/content';
import { OptimizedImage } from './OptimizedImage';
type ModuleTileProps = {
  module: Module;
};
export function ModuleTile({
  module
}: ModuleTileProps) {
  return <figure className="flex flex-col" data-id="element-111" data-mp="2ngqc933yfypb">
      <div className="relative overflow-hidden rounded-xl bg-brand-100 shadow-[0_14px_30px_-16px_rgba(23,49,59,0.5)]" data-id="element-112" data-mp="2nhrnp8ovun7k">
        <OptimizedImage src={module.cover} alt={`Portada del Tomo ${module.number}: ${module.title}`} width={560} height={784} className="aspect-[5/7] h-auto w-full object-cover" data-id="element-113" data-mp="3g4cqd5at6lqf" />
        <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-sun font-display text-sm font-extrabold text-ink" data-id="element-114" data-mp="3b7cj4r283cxq">
          {module.number}
        </span>
      </div>
      <figcaption className="mt-2" data-id="element-115" data-mp="32b4ydcitfo87">
        <ul className="flex flex-wrap gap-1" data-id="element-116" data-mp="2ppv6upgfd7m">
          {module.features.map(f => <li key={f.label} className="rounded-md bg-brand-50 px-1.5 py-0.5 text-[11px] font-semibold leading-tight text-brand-800" data-id="element-117" data-mp="3u45fiw6ostwa">
              {f.label}
            </li>)}
        </ul>
      </figcaption>
    </figure>;
}